<template>
  <div
    :class="['x-option-selection', { 'one-option-selection': layout.length === 1 ? true : false }]"
  >
    <template v-for="(item, index) in layout">
      <template v-if="item.type === 'select' && !item.hidden">
        <el-select
          v-model="filter[item.key]"
          :class="[{ 'box-shadow': item.noBorder }]"
          :clearable="!item.clearable"
          size="small"
          :filterable="item.filterable"
          :popper-append-to-body="item.a"
          :placeholder="item.placeholder"
          @change="change(item.event, $event)"
        >
          <el-option
            v-for="(every, i) in item.option"
            :label="every[(item.props && item.props.label) || props.label]"
            :value="every[(item.props && item.props.value) || props.value]"
            :key="i"
          ></el-option>
        </el-select>
      </template>
      <template v-if="item.type === 'input'">
        <el-input
          :class="['x-el-input', { 'box-shadow': item.noBorder }]"
          v-model="filter[item.key]"
          size="small"
          :style="{ width: item.width || '' }"
          :placeholder="item.placeholder"
          suffix-icon="el-icon-search"
          @input="changeInput"
        ></el-input>
        <el-button v-if="!item.hideBtn" type="primary" size="small" @click="seach">{{
          $t('HT.search2')
        }}</el-button>
      </template>
      <template v-if="item.type === 'date'">
        <template v-if="item.key">
          <el-date-picker
            ref="datePicker"
            :class="{ 'box-shadow': item.noBorder }"
            v-model="filter[item.key]"
            type="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :start-placeholder="$t('HT.startDate')"
            :end-placeholder="$t('HT.endDate')"
            :picker-options="item.option || timeOption"
            size="small"
            @change="changeDate"
          ></el-date-picker>
        </template>
        <template v-else>
          <el-date-picker
            ref="datePicker"
            :class="{ 'box-shadow': item.noBorder }"
            v-model="date"
            type="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy/MM/dd"
            :start-placeholder="$t('HT.startDate')"
            :end-placeholder="$t('HT.endDate')"
            :picker-options="item.option || timeOption"
            size="small"
            @change="changeDate"
          ></el-date-picker>
        </template>
      </template>
      <template v-if="item.type === 'dateTime'">
        <el-date-picker
          ref="datePicker"
          :class="{ 'box-shadow': item.noBorder }"
          v-model="filter[item.key]"
          type="datetimerange"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy/MM/dd HH:mm:ss"
          :start-placeholder="$t('HT.startDate')"
          :end-placeholder="$t('HT.endDate')"
          :picker-options="item.option || timeOption"
          size="small"
          @change="changeDate"
        ></el-date-picker>
      </template>
      <template v-if="item.type === 'time'">
        <el-time-picker
          is-range
          v-model="filter[item.key]"
          range-separator="-"
          format="HH:mm"
          value-format="HH:mm"
          :start-placeholder="$t('HT.startTime')"
          :end-placeholder="$t('HT.endTime')"
          size="small"
          @change="changeTime"
        ></el-time-picker>
      </template>
      <template v-if="item.type === 'area'">
        <my-area v-model="selectedArea" clearable @change="changeArea"></my-area>
      </template>
      <template v-if="item.type === 'button' && item.show">
        <el-button
          :class="[
            'x-add-btn',
            { 'x-right-add-btn': !item.left, 'left-margin': item.left, 'box-shadow': item.noBorder }
          ]"
          type="primary"
          :icon="item.icon"
          size="small"
          @click="clickEvent(item.event)"
          >{{ item.text }}</el-button
        >
      </template>
    </template>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'MySeachOption',
  props: {
    layout: {
      // 配置
      type: Array,
      default: () => {
        return [];
      }
    },
    model: {
      // 需要绑定的数据
      type: Object,
      default: () => {
        return {};
      }
    },
    props: {
      type: Object,
      default: () => {
        return {
          label: 'label',
          value: 'value'
        };
      }
    }
  },

  data() {
    return {
      filter: this.model, // 整个筛选对象
      date: [], // 起始时间
      selectedArea: [], // 三级地区
      timeOption: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      }
    };
  },

  methods: {
    /**
     * 节流搜索
     */
    debounce: _.debounce(function (val) {
      this.$emit('input', val);
    }, 300),

    seach() {
      this.$emit('seach');
    },

    /**
     * 选择器筛选
     * @param {String} event 事件名
     */
    change(event, val) {
      this.$emit(event, val);
    },

    /**
     * 改变时间选择
     * @param {Array} val 起始时间数组
     */
    changeDate(val) {
      if (val) {
        let startTime = new Date(val[0]).getTime();
        let endTime = new Date(val[1]).getTime();
        if (endTime - startTime > 7776000000) {
          this.$uxMessage.warning(this.$t('HT.changeDateMessage'));
          this.$refs.datePicker[0].focus();
          return;
        }
        this.$emit('changeTime', val);
      } else {
        this.$emit('changeTime', []);
      }
    },

    /**
     * 改变时间(时分)
     * @param {Array} val 起始时间数组
     */
    changeTime(val) {
      this.$emit('changeTime', val);
    },

    /**
     * 点击事件传替
     * @param {String} event 事件名
     */
    clickEvent(event) {
      this.$emit(event);
    },

    /**
     * 改变三级城市
     * @param {Array} val 三级地区数组
     */
    changeArea(val) {
      this.$emit('changeArea', val);
    },

    /**
     * 输入框改变
     * @param {String} val 输入的字段
     */
    changeInput(val) {
      this.debounce(val);
    }
  }
};
</script>

<style lang="scss" scoped>
// 选择筛选栏各种选择器以及搜索框
.x-option-selection {
  display: flex;
  align-items: center;
  height: 70px;
  min-height: 70px;

  .left-margin {
    margin-right: 10px;
  }

  .el-select {
    flex: 1;
    max-width: 100px;
    margin-right: 10px;
  }

  // 输入框默认300px
  .x-el-input {
    flex: 1;
    max-width: 300px;
    margin-right: 10px;
  }

  // 日期选择器
  .el-date-editor.el-range-editor--small.el-input__inner {
    flex: 1;
    height: 30px;
    max-width: 220px;
    margin-right: 10px;

    .el-range-separator {
      line-height: 22px;
    }
  }

  .my-area {
    max-width: 400px;
  }

  .x-right-add-btn {
    margin-left: auto;
  }
}

// 只有一个的情况下
.one-option-selection {
  .el-select,
        // .x-el-input,
        .el-date-editor {
    margin: 0;
  }
}
</style>

<style lang="scss">
.x-option-selection {
  .box-shadow {
    border: 0 none;
    box-shadow: 0 0 6px #d7dde7;

    .el-input__inner {
      border: 0 none;
    }
  }
}
</style>
